"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('angular2/core');
var notification_1 = require('./notification');
var App = (function () {
    function App() {
        this.notificationRemoveDelay = 8000;
    }
    App.prototype.onRemove = function (notification) {
        console.log('Remove', notification);
    };
    App = __decorate([
        core_1.Component({
            selector: 'app',
            directives: [notification_1.Notifications],
            template: "\n    <div class=\"app\">\n      <hx-notify\n        [removeDelay]=\"notificationRemoveDelay\"\n        (onRemove)=\"onRemove($event)\">\n      </hx-notify>\n    </div>\n  "
        }), 
        __metadata('design:paramtypes', [])
    ], App);
    return App;
}());
exports.App = App;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/app.ts
 ** module id = 243
 ** module chunks = 0
 **/